'use client';

import type { LogoItem } from './LogoLoop';
import type { TranslationKeys } from '../types';

interface BuildingForSectionProps {
  t: TranslationKeys;
}

const MOCK_LOGOS: LogoItem[] = [
  {
    id: 'ata',
    name: 'American Translators Association',
    imageUrl: '/images/brand/asociacion-ata.jpg',
  },
  {
    id: 'aneti',
    name: 'ANETI',
    imageUrl: '/images/brand/asociacion-aneti.png',
  },
  {
    id: 'alc',
    name: 'ALC',
    imageUrl: '/images/brand/asociacion-alc.png',
    // ALC artwork is a wide lockup — scale down so it sits visually next
    // to ATA / ANETI rather than dwarfing them.
    sizeClass: 'h-[28px] md:h-[40px] lg:h-[48px]',
  },
];

export default function BuildingForSection({ t }: BuildingForSectionProps) {
  return (
    <section aria-label={t.whoTrustsUs} className="bg-white px-4 pt-2 pb-6 md:pt-4 md:pb-8">
      <div className="mx-auto w-full max-w-[1600px]">
        <header className="mb-4 md:mb-5">
          <h2 className="text-center text-2xl md:text-4xl !leading-[1.1] font-bold text-gray-900">
            {t.whoTrustsUs}
          </h2>
        </header>

        <div
          className="group/logos flex min-h-[88px] items-center justify-center gap-14 md:min-h-[104px] md:gap-24"
          role="region"
          aria-label="Logos de asociaciones"
        >
          {MOCK_LOGOS.map((logo) => {
            const sizeClass = logo.sizeClass ?? 'h-[72px] md:h-[100px] lg:h-[115px]';
            return (
              <img
                key={logo.id}
                src={logo.imageUrl}
                alt={logo.name}
                className={`${sizeClass} w-auto object-contain grayscale opacity-65 transition duration-300 hover:grayscale-0 hover:opacity-100`}
                loading="lazy"
              />
            );
          })}
        </div>
      </div>
    </section>
  );
}
